import React from "react";
import { CircularProgress, Box } from "@mui/material";

type LoaderProps = {
  color?:
    | "primary"
    | "secondary"
    | "inherit"
    | "error"
    | "info"
    | "success"
    | "warning";
  size?: number;
  thickness?: number;
};

const Loader: React.FC<LoaderProps> = ({
  color = "primary",
  size = 40,
  thickness = 3.6,
}) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <CircularProgress color={color} size={size} thickness={thickness} />
    </Box>
  );
};

export default Loader;
